import { Injectable } from "@angular/core";
import { Observable, forkJoin, of, throwError, Subject } from "rxjs";
import { AUTH_TYPE_HEADER, AuthService, AuthType } from "./auth.service";
import { Addon } from "src/app/shared/models/addon.model";
import { map, switchMap, mergeMap, tap, catchError } from "rxjs/operators";
import { environment } from "src/environments/environment";
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpRequest,
  HttpErrorResponse
} from "@angular/common/http";
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router, ActivatedRoute } from '@angular/router';
import { UserInfoService } from '../../requests/esp/common/services/userinfo-service';
import { VacancyService } from "./vacancy.service";
import { UserService } from "./user.service";
import { CACHE_SKIP_HEADER } from "../inteceptors/http-cache.interceptor";


@Injectable({
  providedIn: 'root'
})
export class HigherAuthService {

  constructor(
    private _authService: AuthService,
    private http: HttpClient,
    private _userInfoService: UserInfoService,
    private userService: UserService
  ) {
  }

  getESPAddons(): Observable<Addon> {
    return this._authService.getAddonsAuth(this._authService.idenediGroupId).pipe(
      map((addons) => {
        return addons.find(
          (addon) => addon.Type.toLowerCase() == AuthType.ESP.toLowerCase()
        );
      })
    );

  }

  getHigherAuth(): Observable<Addon> {
    return this._authService.getAddonsAuth(this._authService.idenediGroupId).pipe(
      map((addons) => {
        const addon = addons.find(
          (addon) => addon.Type.toLowerCase() === AuthType.Higher.toLowerCase()
        );
    
        if (addon) {
          if (!addon.OrganziationId && addon.PublicProperties?.organziationId) {
            addon.OrganziationId = addon.PublicProperties.organziationId;
          }
    
          if (!addon.GroupIdenedi && addon.PublicProperties?.groupIdenedi) {
            addon.GroupIdenedi = addon.PublicProperties.groupIdenedi;
          }
        }
    
        return addon;
      })
    );

  }

  getIdenediCode(): Observable<string> {
    let url = `${environment.idenediProviderUrl}/api/oauth/AuthorizationCode??client_id=XHT1962131100`;
    if (this._authService.idenediGroupId) {
      url = `${environment.idenediProviderUrl}/api/oauth/AuthorizationCode?client_id=XHT1962131100&gIdenedi=${this._authService.idenediGroupId}`;
    }
    //const url = `https://idenedi-prod-stag.azurewebsites.net/api/oauth/AuthorizationCode?client_id=XHT1962131100`;
    const options = {
      headers: this._authService.buildAuthHeader(AuthType.Idenedi),
    };
    return this.http.get<any>(url, options).pipe(
      map((code) => {
        return code;
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          return error.status.toString();
        }

      })
    );
  }

  getHigherToken(): Observable<Addon> {
    return this.getHigherAuth().pipe(
      switchMap((addon) => {
        if (!addon) {          
          return of(null);
        }
        if (addon?.AccessToken) {          
          return of(addon);
        } else {                  
          if(addon?.OrganziationId && addon?.GroupIdenedi){            
            return forkJoin([this.getHigherAuth(), this.getIdenediCode()]).pipe(
              switchMap((results) => {
                // results[0] is our getHigherAuth() - addon
                // results[1] is our getIdenediCode() - code
                //http://qaesp.azurewebsites.net/webapi/orguser/idenediTokenV2/{code}/{orgId}
  
                if(results[1] == '1'){
                  return of(results[0]);
                }else{
                  // let data = 'grant_type=password&client_id=higherWeb&idenedi_token='+encodeURIComponent(results[1])+'&grant_access=idenedi&org_id='+results[0].OrganziationId + '&group_id='+results[0].GroupIdenedi;
                  this.deleteHigherUserInfo()
                  return this.http
                    // .post<any>(
                    //   //hiher base url from getHigherAuth + higher token URL
                    //   //send idendi token/code
  
                    //   `${results[0].BaseUrl}/token`,data
                    // )
  
                    .get<any>(                    
                      `${results[0].BaseUrl}/api/idenediAuth/idenediToken/${encodeURIComponent(results[1])}/${results[0].OrganziationId}/${results[0].GroupIdenedi}`
                    )
                    .pipe(
                      map((resp) => {
                        this.setHigherUserInfo(resp);
                        //console.log(resp);
                        // results[0].AccessToken = resp.token.accessToken;
                        // this._userInfoService.role = resp.user.role;
                        // this._userInfoService.isApplicant = resp.user.isApplicant;
                        // this._userInfoService.imageUrl = resp.user.imageUrl;
                        return results[0];
                      }),
                      catchError((error: HttpErrorResponse) => {
                        if (error.error.error === 'IdenediUserNotFound') {
                          //console.log(error.error)
                          return of(results[0]);
                        }else if(error.error.error ==='InvalidCredentials'){
                          return of(results[0]);
                        }else if(error.error.error ==='IdenediUserNotLinked'){
                          return of(results[0]);
                        }
  
                      })
                    );
                }
  
              })
            );
          }
          else{            
            return forkJoin([this.getIdenediCode()]).pipe(
              switchMap((results) => {                  
                if(results[0] == '1'){
                  return of(addon);
                }else{
                  
                  this.deleteHigherUserInfo()
                  return this.http                    
                    .get<any>(                    
                      `${addon.BaseUrl}/api/idenediAuth/idenediToken/${encodeURIComponent(results[0])}/${addon.PublicProperties?.organziationId}/${addon.PublicProperties?.groupIdenedi}`
                    )
                    .pipe(
                      map((resp) => {
                        this.setHigherUserInfo(resp);
                        //console.log(resp);
                        // addon.AccessToken = resp.token.accessToken;
                        // this._userInfoService.role = resp.user.role;
                        // this._userInfoService.isApplicant = resp.user.isApplicant;
                        // this._userInfoService.imageUrl = resp.user.imageUrl;
                        return addon;
                      }),
                      catchError((error: HttpErrorResponse) => {
                        if (error.error.error === 'IdenediUserNotFound') {
                          //console.log(error.error)
                          return of(addon);
                        }else if(error.error.error ==='InvalidCredentials'){
                          return of(addon);
                        }else if(error.error.error ==='IdenediUserNotLinked'){
                          return of(addon);
                        }
  
                      })
                    );
                }
  
              })
            );

          }

          
        }
      })
    );
  }

  setHigherUserInfo(userInfo){
    localStorage.setItem('higherUser',JSON.stringify(userInfo))
  }

  deleteHigherUserInfo(){
    localStorage.removeItem('higherUser');
  }

  getHigherUserInfo(){
    let data = JSON.parse(localStorage.getItem('higherUser'))
    return data;
  }

  getHeader(){
    let header;
    let addonT;
    let userInfo = this.getHigherUserInfo();
    let idenediKey = localStorage.getItem('idenedi.user.id');
    this.getHigherAuth()
    .subscribe(function(addon){
      addonT = addon
    });


    if(userInfo && userInfo.access_token){
      header = new HttpHeaders()
      .set("Authorization","Bearer " + userInfo.access_token)
      .set("OrganizationId", String(addonT?.OrganziationId))
      .set("IdenediKey", String(idenediKey));
      //.set("groupId", String(addonT.GroupIdenedi));      
    }else{
      header = new HttpHeaders()
      .set("OrganizationId", String(addonT?.OrganziationId))
      .set("IdenediKey", String(idenediKey));
    }
    return {headers:header};
  }

  registerUserOnHigher(){
    this.getHigherToken()
    .subscribe(function(addon){
      console.log(addon)
    });
  }


  linkJobSeekerAccount(key){
    let addonT;
    let currentUserIdendidiKey;
    this.getHigherAuth()
    .subscribe((addon)=>{
      addonT = addon
      this.userService.getCurrentUser().subscribe((user) => {
        if(user){
          currentUserIdendidiKey = user.UserIdenedi
          this.http
          .post<any>(`${addonT.BaseUrl}/api/JobSeekerAccount/link`,{jobSeekerKey:key,idenediKey:currentUserIdendidiKey})
          .subscribe((resp)=>{
            console.log(resp)
          })
          // .pipe(
          //   map((resp) => {
          //     console.log(resp)
          //     return 'asd';
          //   }),
          //   catchError((error: HttpErrorResponse) => {
          //     console.log(error)
          //     if (error.error.error === 'IdenediUserNotFound') {
          //       //console.log(error.error)
          //       return 'asd';
          //     }

          //   })
          // );
        }
      })

    });

  }

  addExternalUserToHigher(){
    let addonT;
    let currentUserIdendidiKey;
    this.getHigherAuth()
    .subscribe((addon)=>{
      addonT = addon
      if(addonT){
        let header = new HttpHeaders()
        .set("OrganizationId", String(addonT?.OrganziationId));
       this.getIdenediCode().subscribe((res) => {
        if(res){
          this.http
          .post<any>(`${addonT.BaseUrl}/api/externaluser/create`,{groupId:addonT.GroupIdenedi,idenediCode:encodeURIComponent(res)},{headers:header})
          .subscribe((resp)=>{
            console.log(resp)
          })
        }
      })
      }

    });
  }

  updateMembersForBusniessUnit(businessUnitKey){
    let addonT;
    let currentUserIdendidiKey;
    this.getHigherAuth()
    .subscribe((addon)=>{
      addonT = addon
      if(addonT){
        let header = new HttpHeaders()
        .set("OrganizationId", String(addonT?.OrganziationId));
       this.getIdenediCode().subscribe((res) => {
        if(res){
          this.http
          .get<any>(`${addonT.BaseUrl}/api/businessUnit/sync/${businessUnitKey}/${addonT.GroupIdenedi}`,this.getHeader())
          .subscribe((resp)=>{
            console.log(resp)
          })
        }
      })
      }

    });
  }

  higherUserToken(){
    return new Promise((resolve, reject) => {
      this.getHigherToken()
        .subscribe({
          next: (addon) => resolve(addon),
          error: (err) => reject(err)
        });
    });
  }

  checkUserLogin(){
   return this._authService.isLoggedIn();
  }
}





@Injectable({
  providedIn: "root",
})
export class HigherTokenResolverService  {
  constructor(private _HigherAuthService: HigherAuthService, private _authService: AuthService) {}

  resolve(route: ActivatedRouteSnapshot = null): Observable<any> {
    if (!this._authService.isLoggedIn() && (route?.data?.ignoreToken == null || route?.data?.ignoreToken == true)) {
      return of(true)
    }
    // if (route?.data?.ignoreToken && !this._authService.isLoggedIn()) {
    //   return of(true)
    // }
    else {
      return this._HigherAuthService.getHigherToken().pipe(map(HigherAddon => HigherAddon));
    }
  }

  // resolve() {
  //   return this._HigherAuthService.getHigherToken().pipe(map((HigherAddon) => HigherAddon));
  // }
}


@Injectable({
  providedIn: "root",
})
export class HigherLoginResolverService  {
  private destroy$: Subject<void> = new Subject<void>();
  constructor(private router: Router, private route: ActivatedRoute, private vacancyService: VacancyService, private userService: UserService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const currentUser = JSON.parse(localStorage.getItem('higherUser'));
    const currentUserIdendidiToken = localStorage.getItem('idenedi.auth.token');
    let currentUserIdendidiKey = localStorage.getItem('idenedi.user.id');

    // if(!currentUserIdendidiKey){
    //   this.userService.getCurrentUser().subscribe((user) => {
    //     if(user){
    //       currentUserIdendidiKey = user.UserIdenedi
    //     }
    //   })

    // }

    if (currentUser && (currentUser?.role == 'Administrator' || (currentUser?.role == 'User' && currentUser?.teamRole == 'Recruiter'))) {
      return true;
    }else if(currentUserIdendidiToken){
      let teamNo  =window.location.href.indexOf('team')
      if(teamNo > 0){
        let teamInfo = window.location.href.slice(teamNo,1000)
        let team = teamInfo.split('=') //team[1]
        if(team[1]){
          return this.vacancyService.getTeamByCode(team[1])
          .pipe(
            map((resp) => {
                if(resp == 'Invalid Code'){
                  this.router.navigate(['/pages/vacancies']);
                  return false;
                }else{
                  //this.router.navigate(['/pages/vacancies/add?team=398728']);
                  return true;
                }
            }))
          // .subscribe(res => {
          //   console.log(res);
          //   if(res == 'Invalid Code'){
          //     //this.router.navigate(['/pages/vacancies']);
          //     return false;
          //   }else{
          //     //this.router.navigate(['/pages/vacancies/add?team=398728']);
          //     return true;
          //   }
          // })

        }else{
          this.router.navigate(['/pages/vacancies']);
          return false;
        }
      }
    }else{
      this.router.navigate(['/auth/login']);
      return false;
    }

  }
}
